import { FC } from "react";
import {
  campaignPercentageSettings,
  numericModalSettings,
  numericSettingsTitles,
} from "../constants";
import { NamedNumberic } from "../../ui/layout/molecules/NamedNumberic";
import { CampaignBody } from "@vviinn/user-managment-client-ts";
import { HandleCampaignChange } from "../types";

export type CampaignNumbericKey = keyof typeof numericModalSettings;

export const CampaignNumberic: FC<{
  campaignKey: CampaignNumbericKey;
  campaign: CampaignBody;
  handleChange: HandleCampaignChange;
}> = ({ campaignKey, campaign, handleChange }) => (
  <NamedNumberic
    {...numericModalSettings[campaignKey]}
    title={numericSettingsTitles[campaignKey]}
    value={campaign[campaignKey]}
    onChange={(target: HTMLInputElement) =>
      handleChange(campaignKey, true)(target.value)
    }
    addPercentage={campaignPercentageSettings.some(
      (key) => key === campaignKey,
    )}
  />
);
